/** @jsx jsx */

import { ReactNode } from 'react';

import { jsx } from '@emotion/core';
import { Icon, IconName } from '@zapier/zinnia-icons';
import { Grid, Margin, Text } from '@zapier/design-system';

type Props = {
  description: string | ReactNode;
  icon: IconName;
};

export default function TodosSimple({ description, icon }: Props) {
  return (
    <Margin margin="10px 0px 10px 0px">
      <Grid alignItems="center" columns="auto 1fr" gap="15px">
        <Icon name={icon} size={24} />
        <Text type="Body1">{description}</Text>
      </Grid>
    </Margin>
  );
}
